import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";

const VARIANTS = {
  primary:
    "bg-accent text-bg-base hover:bg-accent-hover disabled:bg-accent/40 disabled:text-bg-base/60",
  secondary:
    "border border-border bg-bg-elevated text-text-primary hover:border-accent hover:text-accent disabled:opacity-50",
  ghost: "text-text-secondary hover:text-text-primary hover:bg-bg-elevated-2 disabled:opacity-50",
  danger: "bg-danger text-white hover:bg-danger/90 disabled:opacity-50",
  outlineDanger:
    "border border-danger text-danger hover:bg-danger hover:text-white disabled:opacity-50",
};

const SIZES = {
  sm: "h-8 px-3 text-xs",
  md: "h-10 px-4 text-sm",
  lg: "h-12 px-6 text-base",
};

export const Button = forwardRef(
  (
    {
      variant = "primary",
      size = "md",
      type = "button",
      leftIcon,
      rightIcon,
      loading = false,
      disabled,
      className,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled || loading}
        className={cn(
          "inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-bg-base disabled:cursor-not-allowed",
          VARIANTS[variant],
          SIZES[size],
          className
        )}
        {...props}
      >
        {loading ? (
          <span
            aria-hidden
            className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
          />
        ) : (
          leftIcon
        )}
        {children}
        {!loading && rightIcon}
      </button>
    );
  }
);
Button.displayName = "Button";
